export default __webpack_public_path__ + "static/media/rlLab2Low.51393541.jpg";